import { WalletPlusOutlineIcon } from './WalletPlusOutlineIcon';

/**
 * author: GreenTurtwig
 * id 1BDED2D9-31E7-457D-AA32-6CE990645545
 * name wallet-plus-outline
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wallet-plus-outline.svg
 * tags
 * - Banking 
 */
export const WalletAddOutlineIcon = WalletPlusOutlineIcon;
export default WalletAddOutlineIcon